import React from "react";
import { withTranslation } from "react-i18next";
import { Grid, Pagination } from "semantic-ui-react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";

@observer
class PaginatedTable extends React.Component {
  render() {
    const { totalItemsCount, pagination, children, changePageCallback, t } = this.props;

    return (
      <Grid>
        <Grid.Row>
          <Grid.Column>
            {totalItemsCount > 0 ? (
              <p>
                {t("showingFromToOfTotal", {
                  paginationShowingFrom: pagination.showingFrom,
                  paginationShowingTo: pagination.showingTo,
                  paginationTotal: pagination.total,
                })}
              </p>
            ) : null}
            {children}
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column textAlign="center">
            {totalItemsCount > 0 ? (
              <Pagination
                activePage={pagination.currentPage}
                onPageChange={(_e, data) => changePageCallback(data.activePage)}
                totalPages={pagination.totalPages}
              />
            ) : null}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

PaginatedTable.propTypes = {
  totalItemsCount: PropTypes.number.isRequired,
  // We let the upper component to bootstrap JobsTable for simplicity and avoid deep nesting
  children: PropTypes.element,
  pagination: PropTypes.shape({
    showingFrom: PropTypes.number,
    showingTo: PropTypes.number,
    total: PropTypes.number,
    currentPage: PropTypes.number,
    totalPages: PropTypes.number,
  }),
  changePageCallback: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(PaginatedTable);
